import { ZOOM_3D_MAX_FACTOR, ZOOM_3D_MIN_FACTOR, ZOOM_3D_STEP_RATIO } from '@/config';

// The 3D camera frames the product at a distance factor: dividing it moves the
// camera closer, multiplying it moves it away. Stepping is clamped rather than
// refused, and the two directions are exact inverses — the previous nudges used
// 0.85 in and 1.15 out, so alternating them crept 2.25 % closer every pair.
function zoom3dFactorIn(current: number): number {
    return Math.max(current / ZOOM_3D_STEP_RATIO, ZOOM_3D_MIN_FACTOR);
}

function zoom3dFactorOut(current: number): number {
    return Math.min(current * ZOOM_3D_STEP_RATIO, ZOOM_3D_MAX_FACTOR);
}

// Floating-point slack: a clamped factor lands exactly on its bound, but it got
// there through divisions, so an exact test can miss by an ulp and leave a
// button live at the limit.
const ZOOM_3D_FACTOR_EPSILON = 0.0001;

function hasZoom3dRoomIn(current: number): boolean {
    return current > ZOOM_3D_MIN_FACTOR + ZOOM_3D_FACTOR_EPSILON;
}

function hasZoom3dRoomOut(current: number): boolean {
    return current < ZOOM_3D_MAX_FACTOR - ZOOM_3D_FACTOR_EPSILON;
}

export { hasZoom3dRoomIn, hasZoom3dRoomOut, zoom3dFactorIn, zoom3dFactorOut };
